import {useState, useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {Box} from '@mui/material'
import {useSnackbar} from 'notistack'

export function OnboardingPaymentFailed() {
  const navigate = useNavigate()
  const {enqueueSnackbar} = useSnackbar()
  const [countdown, setCountdown] = useState(5)

  useEffect(() => {
    // Show error notification
    enqueueSnackbar('Payment failed. Redirecting to subscription selection...', {
      variant: 'error',
    })

    // Countdown timer
    console.log('Redirecting to registration with subscription step')
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval)
          // Redirect to registration with subscription step
          // We'll use state to indicate which step to show
          const moduleurl = localStorage.getItem('registration_module_url')
          navigate(`/auth/registration/onboarding?createbusiness=${moduleurl}`, {
            state: {
              returnToStep: 'subscription',
              paymentFailed: true,
            },
          })
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [navigate, enqueueSnackbar])

  const handleRetryNow = () => {
    const moduleurl = localStorage.getItem('registration_module_url')
    navigate(`/auth/registration/onboarding?createbusiness=${moduleurl}`, {
      state: {
        returnToStep: 'subscription',
        paymentFailed: true,
      },
    })
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '20px',
      }}
    >
      <div className='w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto text-center'>
        <div className='mb-5'>
          <i className='bi bi-x-circle text-danger' style={{fontSize: '80px'}}></i>
        </div>

        <h1 className='text-dark mb-3'>Payment Failed</h1>

        <p className='text-gray-600 fs-5 mb-5'>
          Unfortunately, your payment could not be processed. This could be due to insufficient
          funds, incorrect payment details, or a network issue.
        </p>

        <div className='alert alert-danger mb-5'>
          <div className='alert-text font-weight-bold'>
            Your subscription was not activated. No charges were made to your account.
          </div>
        </div>

        <p className='text-gray-500 fs-6 mb-5'>
          Redirecting to subscription selection in <strong>{countdown}</strong> seconds...
        </p>

        <button type='button' className='btn btn-primary btn-lg' onClick={handleRetryNow}>
          Retry Payment Now
        </button>

        <div className='mt-5'>
          <p className='text-gray-500 fs-7'>Need help? Contact our support team for assistance.</p>
        </div>
      </div>
    </Box>
  )
}
